import React, { useContext, useEffect, useState } from 'react';
import "./bill.css";
import Application from '../../StateContext/Application';

const AdministrativeApprovalCreation = () => {
    const operation = useContext(Application);
    const { AdministrativeApprovalCreation, GetBudgetHeadInfo } = operation;

    const [show, setShow] = useState(false);
    const [HeadInfo, setHeadInfo] = useState([]);
    const [tableContainer, setTableContianer] = useState([]);
    const [selectedProposals, setSelectedProposals] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [FDistrict, setFDistrict] = useState();

    const [HeadCode, setHeadCode] = useState([]);
    const [FetchedFData, setFetchedFData] = useState([]);
    const [FTaluka, setFTaluka] = useState([]);
    const [FetchedDistrict, setFetchedDistrict] = useState([]);

    const [GrnID, setGrnID] = useState([]);
    const [SelectedGrnData, setSelectedGRNData] = useState([]);
    const [ProposalID, setProposalID] = useState([]);
    const [TechnicalSanctionUid, setTechnicalSanctionUid] = useState([]);
    const [SelectedTechUID, setSelectedTechUID] = useState([]);

    const [data, setData] = useState({
        HeadCode: "",
        ProposalYear: "",
        GRUID: "",
        GovernmentApprovalNumber: "",
        GovernmentApprovalDate: "",
        GovernmentOrderNo: "",
        GovernmentOrderDate: "",
        GovernmentOrderEndDate: "",
        TechnicalUID: "",
    });

    const [loading, setLoading] = useState(false);

    const HandleChangeData = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });

    };

    const formData = new FormData();
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (selectedProposals.length <= 0) {
            return alert("Not selected techincal Sanction from list !!!!");
        }

        let GRCopy = document.getElementById("GRCopy").files;

        //for grampanchayat
        const gramPanchayats = selectedProposals.map(proposal => {
            const proposalData = FetchedFData.find(item => item.Proposal_UID === proposal.ProposalID);
            return proposalData?.GramPanchayat;
        }).filter(Boolean);

        const uniqueGramPanchayats = [...new Set(gramPanchayats)];
        const gramPanchayatString = uniqueGramPanchayats.join(', ');

        //for work name
        const workname = selectedProposals.map(proposal => {
            const proposalData = FetchedFData.find(item => item.Proposal_UID === proposal.ProposalID);
            return proposalData?.WorkName;
        })

        const uniqueWorkName = [...new Set(workname)];
        const workNameString = uniqueWorkName.join(', ');
        if (
            !data.GRUID
            || !data.GovernmentApprovalDate
            || !data.GovernmentApprovalNumber
            || !data.GovernmentOrderDate
            || !data.GovernmentOrderEndDate
            || !data.GovernmentOrderNo
            || !data.HeadCode
            || !data.ProposalYear
            || GRCopy.length === 0
        ) {
            return alert("Required Data is Missing !!!");
        }
        setLoading(true);

        try {
            for (const key in data) {
                formData.append(key, data[key]);
            }
            formData.append("GRCopy", GRCopy[0]);
            formData.append("Amount", totalAmount);
            formData.append("District", FDistrict);
            formData.append("Taluka", FTaluka);
            formData.append("GramPanchayat", gramPanchayatString);
            formData.append("WorkName", workNameString);
            formData.append("selectedProposal", JSON.stringify(selectedProposals))

            console.log("Data i will send to beakcne d:: ", data);

            let result = await AdministrativeApprovalCreation(formData);
            console.log(result);
            alert(result);
            window.location.reload();
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };


    const FetchHeadInfo = async () => {
        try {
            // let res = await GetBudgetHeadInfo("null", "all");
            let res1 = await GetBudgetHeadInfo('null', "AllHeadCode");
            let res2 = await GetBudgetHeadInfo("null", "GetTalukas");
            console.log("Data i get from Bakcend :: ", res1);
            setHeadInfo(res1);
            setHeadCode(res1)
            setFetchedDistrict(res2);
        }
        catch (err) {
            console.log(err);
        }
    };


    useEffect(() => {
        FetchHeadInfo();
    }, []);



    // new function added


    const FetchDataRelatedtogrn = async (id) => {
        try {
            let res = await GetBudgetHeadInfo(id, "GetSpecificTechinalSanction");
            setFetchedFData(res);
            const uniqueGRNID = [...new Set(res.map(item => item.GR_UID))];
            setGrnID(uniqueGRNID);
            console.log("I get GRN :: ", uniqueGRNID);
        }
        catch (err) {
            console.log(err);
        }
    }

    const sortDatabyProposalYear = (year) => {
        if (data.HeadCode) {
            let res = FetchedFData.filter((item) => item.SanctionYear == year);
            const uniqueGRN = [...new Set(res.map(item => item.GR_UID))];
            setGrnID(uniqueGRN);
            // setData({ ...data, GRUID: '' });
            // setFetchedFData(res);
        }
    };


    console.log("__________________", FetchedFData)

    // const sortDataByZilla = (zilla) => {
    //     if (data.HeadCode && data.ProposalYear) {
    //         let res = FetchedFData.filter((item) => item.ZillaParishad == zilla);
    //         const uniqueGRNID = [...new Set(res.map(item => item.GRID))];
    //         setGrnID(uniqueGRNID);
    //     }
    // }

    const sortDataByGrnID = async (id) => {
        if (data.HeadCode && data.ProposalYear) {
            try {
                let res = await GetBudgetHeadInfo(id, "GetSpecificGRNData");
                console.log("Data of GRN Data secidf 888888888888888888 :: ", res);
                const uniqueGRNs = Array.from(
                    new Map(res.map(item => [item.GRID, item])).values()
                );

                // let district = res[0].ZillaParishad;

                const { Taluka, ZillaParishad } = res[0]
                setFDistrict(ZillaParishad);
                setFTaluka(Taluka);

                let res1 = FetchedFData.filter((item) => item.GR_UID == id);
                setFetchedFData(res1);
                setShow(true);
                console.log("res1", res1);
                setTechnicalSanctionUid(res1);
                console.log("Unique GRN Data :: ", uniqueGRNs);
                setSelectedGRNData(uniqueGRNs);
                setSelectedTechUID(res1);
            }
            catch (err) {
                console.log(err);
            }
        }
    }

    const handleCheckboxChange = (e, techincalsanction) => {
        const isChecked = e.target.checked;

        const selectedEntry = {
            ProposalID: techincalsanction.Proposal_UID,
            Proposal_amount: techincalsanction.TechnicalSanctionAmt,
            TechnicalID: techincalsanction.TS_ID
        };

        if (isChecked) {
            setSelectedProposals(prev => [...prev, selectedEntry])
            setTotalAmount(prev => prev + Number(techincalsanction.TechnicalSanctionAmt));
        } else {
            setSelectedProposals(prev => prev.filter(p => p.ProposalID !== techincalsanction.Proposal_UID));
            setTotalAmount(prev => prev - Number(techincalsanction.TechnicalSanctionAmt));
        }
    };


    useEffect(() => {
        if (data.GRUID) {
            sortDataByGrnID(data.GRUID)
        }
    }, [data.GRUID])


    return (
        <>
            <div style={{ height: '91vh', overflowY: 'auto' }}>
                <div className="col-12" style={{ backgroundColor: "#EFF3F8", padding: '2rem 0px 5px 0px' }}>

                    <div className="col-12 m-auto mb-4 budgetContainer">

                        <div className="m-auto budgetElement">
                            <h5 className=' bg-light'>Administrative Approval Creation</h5>
                            <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>Note : Fields marked with * are mandatory</p>

                            {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
                                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                                    }}>
                                    <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
                                    <style>
                                        {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                                    </style>
                                </div>
                            )}
                            <div className="budgetElement2">
                                <form action="">

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5 my-auto ">
                                                <label className='my-auto'>HeadCode <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <select name="HeadCode" value={data.HeadCode} id="" className='py-2' onChange={(e) => {
                                                    HandleChangeData(e);
                                                    FetchDataRelatedtogrn(e.target.value)
                                                }} required>
                                                    < option value="null">Choose Head Code</option>
                                                    {HeadCode && HeadCode.map((val, index) => {
                                                        return (
                                                            <option key={index} value={val.HeadID}>{val.HeadName}</option>
                                                        )
                                                    })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Proposal Year <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <select name="ProposalYear" value={data.ProposalYear} className='py-2' onChange={(e) => {
                                                    HandleChangeData(e);
                                                    sortDatabyProposalYear(e.target.value)
                                                }} required>
                                                    <option value="">Select Proposal Year</option>
                                                    <option value="2024-2025">2024 - 2025</option>
                                                    <option value="2025-2026">2025 - 2026</option>
                                                    <option value="2026-2027">2026 - 2027</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>GR RDD UID <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <select name="GRUID" value={data.GRUID} className='py-2' onChange={(e) => {
                                                    HandleChangeData(e);
                                                }
                                                } required>
                                                    <option value="">Select GR UID </option>
                                                    {
                                                        GrnID &&
                                                        GrnID.map((val, index) => {
                                                            return (
                                                                <option value={val} key={index}>{val}</option>
                                                            )
                                                        })
                                                    }

                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Technical RDD UID <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <select name="TechnicalUID" value={data.TechnicalUID} className='py-2' onChange={(e) => {
                                                    HandleChangeData(e);
                                                }
                                                } required>
                                                    <option value="">Select Technical UID </option>
                                                    {
                                                        TechnicalSanctionUid &&
                                                        TechnicalSanctionUid.map((val, index) => {
                                                            return (
                                                                <option value={val.TS_ID} key={index}>{val.TS_ID}</option>
                                                            )
                                                        })
                                                    }

                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        SelectedGrnData &&
                                        <div className="col-12 m-auto" style={{ backgroundColor: "white", borderRadius: "5px", boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.074)" }}>
                                            <div className="col-12" >


                                                <div className="col-12 my-3">
                                                    <div className="row">

                                                        <div className="col-12">
                                                            <div className="tableContainer m-auto">
                                                                <table style={{ border: '1px solid green' }}>
                                                                    <thead>
                                                                        <tr style={{ background: 'linear-gradient(to Right,#2C78DB)', color: 'white', height: '2.5rem' }}>
                                                                            <th style={{ width: "20%", textAlign: "start" }}>GR UID</th>
                                                                            <th style={{ width: "20%", textAlign: "start" }}>GR Number</th>
                                                                            <th style={{ width: "20%", textAlign: "start" }}>Proposal Year</th>
                                                                            <th style={{ width: "20%", textAlign: "start" }}>GR Amount</th>

                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            SelectedGrnData.length > 0 && data.TechnicalUID ? (
                                                                                SelectedGrnData.map((val, index) => {
                                                                                    return (
                                                                                        <tr key={index} >
                                                                                            <td style={{ textAlign: "start" }}>{val.GRID}</td>
                                                                                            <td style={{ textAlign: "start" }}>{val.GRNumber}</td>
                                                                                            <td style={{ textAlign: "start" }}>{val.ProposalYear}</td>
                                                                                            <td style={{ textAlign: "start" }}>{val.GRAmount}</td>
                                                                                        </tr>

                                                                                    )
                                                                                })
                                                                            ) :
                                                                                (
                                                                                    <tr>
                                                                                        <td colSpan={10}>No Data Found !!</td>
                                                                                    </tr>
                                                                                )
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5 my-auto">
                                                <label className='my-auto'>Government Approval Number <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <input type="text" placeholder='Enter GR Number' className='form-control py-2'
                                                    name='GovernmentApprovalNumber'
                                                    value={data.GovernmentApprovalNumber}
                                                    onChange={HandleChangeData} required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Government Approval Date <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <input type="datetime-local" className='form-control py-2' value={data.GovernmentApprovalDate} name='GovernmentApprovalDate' onChange={HandleChangeData} required max={new Date().toISOString().slice(0, 16)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5 my-auto">
                                                <label className='my-auto'>Amount <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <input type="number" placeholder='Enter Amount' className='form-control py-2'
                                                    value={totalAmount || 0}
                                                    disabled
                                                />
                                            </div>


                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5 my-auto">
                                                <label className='my-auto'>Government Order No <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <input type="text" placeholder='Enter Government Order No' className='form-control py-2'
                                                    value={data.GovernmentOrderNo}
                                                    name='GovernmentOrderNo'
                                                    onChange={HandleChangeData}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5 my-auto">
                                                <label className='my-auto'>Government Order Date <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <input type="datetime-local" className='form-control py-2' value={data.GovernmentOrderDate} name='GovernmentOrderDate' onChange={HandleChangeData} required max={new Date().toISOString().slice(0, 16)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5 my-auto">
                                                <label className='my-auto'>Government Order End Date <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <input type="datetime-local" className='form-control py-2' value={data.GovernmentOrderEndDate} name='GovernmentOrderEndDate' onChange={HandleChangeData} required max={new Date().toISOString().slice(0, 16)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 elements">
                                        <div className="row">
                                            <div className="col-5">
                                                <label>Supporting File <span className='text-danger fw-bold'>*</span></label>
                                            </div>
                                            <div className="col-7">
                                                <input type="file" className='form-control py-2' id='GRCopy' required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 ms-auto mt-5">

                                        <div className="col-12 text-center">
                                            <button className='px-4 py-1 btn btn-primary' onClick={handleSubmit}>Save</button>
                                            <button type="button" className='px-4 py-1 btn btn-danger mx-4' onClick={() => window.location.reload()}>Cancel</button>
                                        </div>


                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>



                    {
                        show &&
                        <div className="extraTable m-auto" style={{ backgroundColor: "white", borderRadius: "5px", boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.074)" }}>
                            <div className="col-12" >


                                <div className="col-12 my-3">
                                    <div className="row">

                                        <div className="col-12">
                                            <div className=" col-12 m-auto">
                                                <h5 className='bg-light fw-bold my-3'>Technical Sanction List</h5>
                                                <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "20px 20px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "68rem" }}>
                                                    <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                                        <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                            <thead>
                                                                <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                                    <th style={{ minWidth: "60px", padding: "8px" }}></th>
                                                                    <th style={{ minWidth: "130px", padding: "8px" }}>HeadCode</th>
                                                                    <th style={{ minWidth: "190px", padding: "8px" }}>TS UID</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>GR UID</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>Proposal ID</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>Proposal Year</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>Technical Sanction No</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>District</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>Taluka</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>Gram Panchayat</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>Work Name</th>
                                                                    <th style={{ minWidth: "160px", padding: "8px" }}>Sanction Amount</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    FetchedFData.length > 0 ? (
                                                                        FetchedFData.map((val, index) => {
                                                                            const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                                            return (
                                                                                <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }} >
                                                                                    <td style={{ padding: '8px' }}>
                                                                                        <input
                                                                                            type='checkbox'
                                                                                            onChange={(e) => handleCheckboxChange(e, val)}
                                                                                            style={{ width: "1.1rem", height: "1.1rem" }}
                                                                                            checked={selectedProposals.some(item => item.ProposalID === val.Proposal_UID)}
                                                                                        />
                                                                                    </td>
                                                                                    <td style={{ padding: '8px' }}>{val.HeadCode}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.TS_ID}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.GR_UID}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.Proposal_UID}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.SanctionYear}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.TechnicalSanctionNo}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.District}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.Taluka}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.GramPanchayat}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.WorkName}</td>
                                                                                    <td style={{ padding: '8px' }}>{val.TechnicalSanctionAmt}</td>

                                                                                </tr>

                                                                            )
                                                                        })
                                                                    ) :
                                                                        (
                                                                            <tr>
                                                                                <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                                                    No data available
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div >
        </>
    );
};

export default AdministrativeApprovalCreation;